
$(function () {
    $('[data-ictpopup-openonload]').each(function () {
        popup(this);
    });
    $('[data-open-popup]').on('click', function () {
        var id = $(this).attr('data-open-popup');
        var p = popup(id);
        p.showPopup(0);
    })

    $('[data-dropdown-open]').on('click', function(){
        $(this).parents('.dropdown').toggleClass('dropdown-open');
    });
    mobileMenu();
});

function mobileMenu(){
    $('[data-tabber]').on('click', function(){
        var id = $(this).attr('data-tabber');
        $('.mobile-tabs label').removeClass('active');
        $('.mobile-tabs .tab-element').removeClass('active');
        $(this).addClass('active');
        $(id).addClass('active');
    });
}


function popup(selector) {
    var overlay = $(selector);

    overlay.showPopup = function(millis) {
        setTimeout(function () {
            $(overlay).css('display', 'flex');
            setTimeout(function () {
                $(overlay).addClass('show');
            }, 300);
        }, millis);
    }

    if ($(selector).length) {
        var close = $(overlay).find('[data-ictpopup-close]');
        var cookies = parseInt($(overlay).attr('data-ictpopup-cookies'));
        var millis = parseInt($(overlay).attr('data-ictpopup-timer')) * 1000;
        var buttons = $(overlay).find('[data-ictpopup]');
        var backs = $(overlay).find('[data-ictpopup-back]');
        var main = $(overlay).find('[data-ictpopup-main]');
        var canShow = $(selector).attr('data-ictpopup-openonload') !== undefined;

        $(close).on('click', function (e) {
            e.preventDefault();
            hidePopup();
        });

        $(buttons).on('click', function () {
            showForm($(this).attr('data-ictpopup'));
        });

        $(backs).on('click', function () {
            hideForms();
        });

        window.addEventListener("klaviyoForms", function (e) {
            if (e.detail.type == 'stepSubmit') {
                if (cookies > 0) {
                    setCookiess("ictpopup", true, cookies);
                }
            }
        });

        function showForm(id) {
            $(id).css('display', 'flex');
            $(main).css('display', 'none');
        }

        function hideForms() {
            $(main).css('display', 'flex');
            $('.step').css('display', 'none');
        }

        if (cookies > 0) {
            var c = getCookie("ictpopup");
            if (c !== undefined)
                canShow = false;
        }

        if (canShow) {
            overlay.showPopup(millis);
        }

        function hidePopup() {
            setTimeout(function () {
                $(overlay).removeClass('show');
                $(overlay).css('display', 'none');
            }, 300);
            if (cookies > 0) {
                setCookiess("ictpopup", true, cookies);
            }
        }
    }
    return overlay;
}


function getCookie(name) {
    const value = `; 
      ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

function setCookiess(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}


// accordion guida taglie
$(document).ready(function($) {
    $('#accordion').find('.accordion-toggle').click(function(){
      //Expand or collapse this panel
        var isActive = $(this).hasClass("active");
            $('.accordion-toggle').removeClass('active')
        if (!isActive) {
            $(this).toggleClass('active');
        }
        $(this).next().slideToggle('fast');     
        //Hide the other panels
        $(".accordion-content").not($(this).next()).slideUp('fast');
    });
});